const pushEvent = (locale, label, action, title) => {
  if (!window.dataLayer) {
    return;
  }

  const platform = window.self !== window.top ? 'standalone' : 'web';

  window.dataLayer.push({
    event: 'gaEvent',
    gaCategory: `Store-${platform}`,
    gaAction: action,
    gaLabel: label,
  });

  window.dataLayer.push({
    event: 'Pageview',
    pagePath: `/#${locale}/${action}`,
    pageTitle: title,
  });
};

const pushEventGA4 = (evName, evParam1, evParam2, evParam3, evParam4) => {
  if (!window.dataLayer) {
    return;
  }

  const params = {
    event: 'ga4_Event',
    evName: evName,
    evParam1: evParam1,
    evParam2: evParam2,
    evParam3: evParam3,
    evParam4: evParam4,
  };

  for (let i = 1; i <= 4; i++) {
    if (typeof params[`evParam${i}`] === 'undefined') {
      delete params[`evParam${i}`];
    }
  }

  window.dataLayer.push(params);
};

const normalizeTariffAlias = (alias) => {
  switch (alias) {
    case 'start':
      return 'view_only';
    case 'pro':
      return 'base';
    case 'businessvr':
      return 'team';
    default:
      return alias;
  }
};

export const Analytics = {
  sendPromo: ({ name, start = '', end = '', discount = '' }) => {
    window.dataLayer.push({
      event: 'gaEvent',
      gaCategory: 'Промокод',
      gaAction: 'Подарок',
      gaLabel: name,
    });

    const startDate = start ? new Date(start * 1000).toLocaleDateString() : '';
    const endDate = end ? new Date(end * 1000).toLocaleDateString() : '';

    pushEventGA4('apply_promo_code', name, startDate, endDate, discount);
  },
  tariffPaySuccess: ({ locale }) => {
    const platform = window.self !== window.top ? 'standalone' : 'web';

    pushEvent(locale, 'view', 'success-tariff', `Изменение тарифа - Оплата прошла успешно (${platform})`);
  },
  openTariffChange: ({ locale }) => {
    const platform = window.self !== window.top ? 'standalone' : 'web';

    pushEvent(locale, 'view', 'tariff-popup', `Изменение тарифа (${platform})`);
  },
  clickTariffChange: ({ locale, oldTariff, newTariff }) => {
    const platform = window.self !== window.top ? 'standalone' : 'web';

    pushEvent(
      locale,
      'click',
      `tariff-payment/${normalizeTariffAlias(oldTariff)}-${normalizeTariffAlias(newTariff)}`,
      `Изменение тарифа: купить ${normalizeTariffAlias(oldTariff)}-${normalizeTariffAlias(newTariff)} (${platform})`
    );
    pushEventGA4('tariff_subscription', oldTariff, newTariff);
  },
  clickBuyTariff: ({ locale, oldTariff, newTariff, promo, term }) => {
    const platform = window.self !== window.top ? 'standalone' : 'web';

    pushEvent(
      locale,
      `${term};${promo}`,
      `payment-tariff/${normalizeTariffAlias(oldTariff)}-${normalizeTariffAlias(newTariff)}`,
      `Изменение тарифа: купить ${normalizeTariffAlias(oldTariff)}-${normalizeTariffAlias(
        newTariff
      )} ${term} (${platform})`
    );
  },
};
